import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: {},
    isAuth: false,
    loading: true,
  },
  reducers: {
    login: (state, action) => {
      state.user = action.payload;
      state.isAuth = true;
      state.loading = false;
    },
    logout: (state) => {
      state.user = {};
      state.isAuth = false;
      state.loading = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { login, logout, setLoading } = authSlice.actions;
export default authSlice.reducer;
